import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { Column } from 'further-ui/components/Layout';
import { styled } from '@mui/material';

const StyledColumn = styled(Column)(() => ({
  minWidth: '150px',
}));

type Props = {
  label: string;
  value: string;
  description: string;
};

const CapitalActionsSummaryStat: FC<Props> = ({
  label,
  value,
  description,
}) => {
  return (
    <StyledColumn spacing="xs" flex={1}>
      <Typography variant="h6">{label}</Typography>
      <Typography variant="body2" color="grey.900">
        {value}
      </Typography>
      <Typography variant="body2">{description}</Typography>
    </StyledColumn>
  );
};

export default CapitalActionsSummaryStat;
